module.exports = __webpack_public_path__ + "static/media/yandex-logo.ddff5ff1.svg";